<template>
  <div>
    <keep-alive>
      <component :is="currentComponent" :payment="student.defaultMethodToPay" />
    </keep-alive>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import cardDefault from './defaults/CardDefault.vue';
import sepaDefault from './defaults/SepaDefault.vue';
import paypalDefault from './defaults/PaypalDefault.vue';

export default {
  components: {
    cardDefault,
    sepaDefault,
    paypalDefault,
  },

  computed: {
    ...mapGetters({
      student: 'auth/student',
    }),

    currentComponent() {
      return `${this.student.default_payment_method}Default`;
    },
  },
};
</script>
